<template>
  <div class="page-builder-layout__stretch">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "PageBuilderSlot",
}
</script>
